export const data =
    [
        [
            "Custom field (Product Portfolio)",
            "Custom field (Product Team)",
            "Custom field (Quarterly Roadmap)",
            "Summary"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "HyperV Infrastructure Data in Devices"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "VMWare Infrastructure in Devices"
        ],
        [
            "Security Management",
            "Security Management",
            "21-Q4",
            "Fortify Assessment Standard : Network Device Discovery"
        ],
        [
            "Security Management",
            "Security Management",
            "21-Q4",
            "Fortify Assessment Standard : Web Content Filtering Assessment"
        ],
        [
            "Security Management",
            "Security Management",
            "21-Q4",
            "Fortify Assessment Standard : Cloud Assessment"
        ],
        [
            "Security Management",
            "Security Management",
            "21-Q4",
            "Fortify Assessment Standard : Endpoint Risk Categories (II) "
        ],
        [
            "Security Management",
            "Security Management",
            "21-Q2",
            "Fortify for Risk Platform - MVP 1.0 - Vulnerability Scanning through Command Integration"
        ],
        [
            "Unified Management",
            "Control",
            "21-Q2",
            "Integrate unattended access agents with Datto RMM"
        ],
        [
            "Unified Management",
            "Control",
            "21-Q2",
            "Update Backstage by enhancing the existing feature set and making it easier to use"
        ],
        [
            "Unified Management",
            "Control",
            "21-Q2",
            "Add ability for partners to save and install differently configured Control agent installers on endpoints"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Script Engine Improvements: addition of different automate style functions"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q1",
            "Implement Script Editor"
        ],
        [
            "Business Management",
            "Business Management",
            "21-Q2",
            "Marketplace reconciliation with Manage agreements"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q3",
            "Work assignment to NOC from any service board"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q3",
            "Avoid device duplication in Manage"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Manage/Command Contact Sync"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Fusion Patching GA"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Partner Defined Patch Approvals "
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Automated Patching (Policy automation)"
        ],
        [
            "Expert Services",
            "ITSM",
            "21-Q1",
            "Integrate Five9 with ConnectWise for Phone & Chat Integration for HD"
        ],
        [
            "Platform Services",
            "Platform Services",
            "21-Q3",
            "Ability to Add & Manage apps in IAM"
        ],
        [
            "Platform Services",
            "Platform Services",
            "21-Q2",
            "IAM User Management"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Policy updates for OS Patching GA"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q1",
            "AccuSearch in Devices "
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Permissions Set for Device Groups"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Intuitively Create and Manage Device Groups"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Critical Criteria Added to Dynamic Device Groups"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "New Page to View and Analyze Device Groups "
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Control Linux Agent Deployment and Launch"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Control Remote Access in Command on Mobile"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Launch Control with 1-Click stored credentials"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Control Mac Agent Deployment and Launch"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Backup portal Control integration"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q1",
            "End-user portal Control integration"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q1",
            "Push Control to LMI Endpoints"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q1",
            "Control Remote Access reporting in Command"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Retire LogMeIn Pro in Command"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q3",
            "2021 Q3 Service and process monitors can be defined for Mac and Linux endpoints"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q3",
            "2021 Q3 Custom monitors functionality for non-admin users"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q3",
            "2021 Q2 Application Install/Uninstall monitor"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q3",
            "2021 Q3 Network (ICMP, SNMP, Public IP, ports) monitors"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q3",
            "2021 Q3 Registry and file system monitors"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "2021 Q2 Monitors support device groups (Static & Dynamic) as target endpoints"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "2021 Q3 Scripts based monitor"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q3",
            "2021 Q3 Monitors can be combined into complex conditiions"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q1",
            "Automation configuration against Monitors Alerts (Pre-defined & Custom)"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "2021 Q3 Performance monitors"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "2021 Q2 Event monitors"
        ],
        [
            "Unified Management",
            "BDR",
            "21-Q2",
            "Integrate the Acronis Cyber Protect product with the ConnectWise Platform"
        ],
        [
            "Platform Services",
            "Platform Services",
            "21-Q2",
            "Enhanced Security Roles"
        ],
        [
            "Platform Services",
            "Platform Services",
            "21-Q4",
            "Decouple Portal From Manage"
        ],
        [
            "Platform Services",
            "Platform Services",
            "21-Q3",
            "Customer Portal Enhancements"
        ],
        [
            "Platform Services",
            "Platform Services",
            "21-Q3",
            "Admin Portal Enhancements"
        ],
        [
            "Platform Services",
            "Platform Services",
            "21-Q1",
            "Multiple Portals"
        ],
        [
            "Business Management",
            "Business Management",
            "21-Q2",
            "BrightGauge Essentials Rollout"
        ],
        [
            "Business Management",
            "Business Management",
            "21-Q1",
            "BrightGauge Essentials for Platform Reporting"
        ],
        [
            "Business Management",
            "Business Management",
            "21-Q1",
            "Business Insights Pilot"
        ],
        [
            "Business Management",
            "Business Management",
            "21-Q2",
            "Business Insights Phase 1"
        ],
        [
            "Unified Management",
            "BDR",
            "21-Q2",
            "Recover - Backup Performance Improvement"
        ],
        [
            "Unified Management",
            "Automate",
            "21-Q1",
            "AUTO-Patching Config in Web: Microsoft Reboot Policy Configuration Screen"
        ],
        [
            "Unified Management",
            "Automate",
            "21-Q2",
            "AUTO-Patching Config in Web: Group and Policy Management"
        ],
        [
            "Unified Management",
            "Automate",
            "21-Q1",
            "AUTO-Patching Config in Web: Third Party Update Policy Configuration Screen"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Conditions Migration from 1.0 to 2.0"
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Automation against the IntelliMon Alert & Custom Monitor "
        ],
        [
            "Unified Management",
            "Command",
            "21-Q2",
            "Suspension 2.0 System"
        ]
    ];
